// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3QQ5Z","col":"Table_col__vHDMj","fulfillmentStatus":"Table_fulfillmentStatus__2kzyU","emailCol":"Table_emailCol__2iq_5"};